import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"
import VueCookies from 'vue-cookies'
import Home from '../views/Home.vue'
import Login from "@/views/Login";
import Forgetlogin from "../views/forgetlogin";
import Result from "../views/result"
import HomePageOverview from "../views/HomePageOverview/Home"
import MemberManagement from '../views/BusinessAdministration/MemberManagement';
import EnterpriseInformation from '../views/BusinessAdministration/EnterpriseInformation';
import PowerDistribution from "../views/PowerDistribution/index";
import Photovoltaic from "../views/Photovoltaic/index";
import Piles from '../views/Piles/index'
import PersonalCenter from "../views/PersonalCenter/index";
import Page404 from "../views/404"

Vue.use(VueRouter)
import {
    disconnect

} from "../mqtt/index";

const routes = [

    {
        path: '/',
        name: 'Home',
        component: Home,
        redirect: "",

        children: [
            {
                path: '/Home/:name/:tag',
                name: 'HomePageOverview',
                component: HomePageOverview,
                props: true
            },
            {
                path: '/PersonalCenter/index',
                name: 'PersonalCenter',
                component: PersonalCenter,
            },
            // {
            //     path: '/Piles',
            //     name: 'Piles',
            //     component: Piles,
            // },
            {
                path: '/3D',
                name: '3d',
                component: () => import('../views/3D/index'),
            },
            // {
            //     path: '/PowerDistribution',
            //     name: 'PowerDistribution',
            //     component: PowerDistribution
            // },
            // {
            //     path: '/Photovoltaic',
            //     name: 'Photovoltaic',
            //     component: Photovoltaic
            // }
        ]
    },

    {
        path: '/admin',
        name: 'Home',
        component: Home,
        redirect: MemberManagement,
        meta: {
            requireAuth: true
        },
        // beforeEach: (to,from, next) => {
        // 	if (to.path == '/') {
        // 		next()
        // 	}

        // 	else {
        // 			console.log(from,"============>")
        // 		next('/login')

        // 	}
        // },
        children: [

            {
                path: '/admin/MemberManagement',
                name: 'MemberManagement',
                component: MemberManagement,

            }, {
                path: '/admin/EnterpriseInformation',
                name: 'EnterpriseInformation',
                component: EnterpriseInformation,

            },
        ],

    },
    {
        path: '/login',
        name: 'Login',
        component: Login,

    },
    {
        path: '/forgetlogin',
        name: 'Forgetlogin',
        component: Forgetlogin
    },
    {
        path: '/result',
        name: 'Result',
        component: Result
    },
    {
        path: '*',
        name: '404',
        component: Page404
    },
]

const router = new VueRouter({
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const getUrlKey = function getUrlKey(name) {
    return (
        decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                location.href
            ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
    );
}

router.beforeEach((to, from, next) => {
    if (store.state.token.isLogin || (to.path === '/login' || to.path === "/forgetlogin" || to.path === "/result")) {
        if (to.path == '/' || to.path == '/admin') {
            disconnect()
            next('/login')
        } else {
            next()
        }
    } else {
        let parse = JSON.parse(sessionStorage.getItem("storeweb"));
        // let parse = VueCookies.get('isLogin')

        if (parse && parse.token.isLogin) {
            next()
        } else {
            if (window.sessionStorage.getItem("token")) {
                parse.token.isLogin = true
                next()
            } else {
                disconnect()
                next("/login")
                store.commit("clear")
                sessionStorage.clear()
            }

        }
    }

})

export default router